var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"menu-profile-item",on:{"click":function($event){return _vm.logout()}}},[_c('log-out-icon',{staticClass:"header-menuitem-icon",attrs:{"size":"14"}}),_c('span',[_vm._v(_vm._s(_vm.$t('dict.logout')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }